/** Keep UI-only product labels and image data out of the tracking API payload. */
export function trackingPayload(event: Record<string, unknown>): Record<string, unknown> {
  const allowed = new Set(['eventId', 'type', 'queryId', 'productId', 'variantId', 'sessionId', 'userId', 'position', 'language', 'currency', 'country', 'device', 'referrer', 'campaign', 'orderId', 'quantity', 'value', 'metadata', 'timestamp']);
  return Object.fromEntries(Object.entries(event).filter(([key, value]) => allowed.has(key) && value !== undefined));
}
